<template>
  <div class="package-container" v-if="initialized">
    <div class="sc-tabs" v-if="productGroups.length > 0">
      <sc-tabs @tabSelect="onTabSelect">
        <sc-tab v-for="group in productGroups" :url="getTabUrl(group)" :selected="selectedTabNodeId === group.code" :key="group.id" :id="group.code">
          <template slot="header">
            <h1 class="page-title" v-if="selectedTabNodeId === group.code">
              <div><b>{{ $t('package.group_name.' + group.code) }}</b></div>
            </h1>
            <div v-else class="text-uppercase">{{ $t('package.group_name.' + group.code) }}</div>
          </template>
          <template>
            <package-comparison-table :packages="filterByLoyalty(group.packages)" @next="onNext"></package-comparison-table>
          </template>
        </sc-tab>

        <template slot="subheader">
          <LoyaltyChipSelector class="chip-select" :values="possibleLoyalties" />
        </template>
      </sc-tabs>

      <div v-if="errorMessage" class="error-message">
        {{ $t(errorMessage) }}
      </div>

      <div class="button-container">
        <rounded-button color="outline" class="next-button" @click="onNext" size="large">
          <span>{{ $t('common.next') }}</span>
        </rounded-button>
      </div>

      <div class="info-message">
        {{ $t('package_selector.price_vat_info') }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  ScTabs,
  ScTab
} from 'smartcommerce-component-library'
import { Routes } from '../utils/Routes'
import LoyaltyChipSelector from '../components/packageselector/LoyaltyChipSelector'
import PackageComparisonTable from '../components/packageselector/PackageComparisonTable'
import productConfigMixin from '../../shared/mixins/productConfigMixin'
import { isEmpty } from '../../shared/utils/common'
import RoundedButton from '../../shared/components/RoundedButton'

export default {
  name: 'PackageSelector',
  components: {
    ScTabs,
    ScTab,
    LoyaltyChipSelector,
    PackageComparisonTable,
    RoundedButton
  },

  mixins: [productConfigMixin],

  data () {
    return {
      routes: Routes,
      selectedTabNodeId: null,
      errorMessage: null,
      initialized: false,
      tableErrorMessage: null
    }
  },

  async created () {
    this.selectedTabNodeId = this.$route.params.groupCode
    await this.getProductConfig()
    const found = this.groups.find(g => g.code === this.selectedTabNodeId)
    if (isEmpty(found)) {
      if (this.$route.path === Routes.home()) {
        const firstGroupCode = this.groups[0].code
        this.$router.replace(Routes.getPackageSelectorUrlForGroupCode(firstGroupCode))
        this.selectedTabNodeId = firstGroupCode
      } else {
        this.$router.replace(Routes.home())
        this.selectedTabNodeId = this.$route.params.groupCode
      }
    }
    this.initialized = true
  },

  computed: {
    productGroups () {
      return this.groups
    }
  },

  methods: {
    onNext () {
      if (this.$store.getters.isCartEmpty()) {
        this.errorMessage = 'package_selector.error_select_package'
        window.scrollTo(0, document.body.scrollHeight)
        return
      }

      this.$router.push(this.routes.VEHICLE_REGISTRATION)
    },

    onTabSelect (selectedTabNode) {
      this.selectedTabNodeId = selectedTabNode.$el.id
    },

    filterByLoyalty (packages) {
      return packages.filter(p => p.loyaltyLength === this.$store.state.selectedLoyalty)
    },

    getTabUrl (group) {
      return Routes.getPackageSelectorUrlForGroupCode(group.code)
    }
  }
}
</script>

<style scoped lang="scss">
h1.page-title {
  margin-bottom: 0;
}

.button-container {
  margin: 2% auto;
  margin-left: 225px;
  width: 662px;

  .next-button {
    margin: auto;
  }
}

.sc-tabs {
  width: 100%;
  margin: 0;
}

.package-container {
  user-select: none;
}

.sc-packages-header {
  font-weight: 500;
  font-size: 30px;
  letter-spacing: 3.3px;
}

.chip-select {
  margin: 40px auto;
  font-size: 14px;
}

.error-message {
  font-size: 14px;
  margin-left: 225px;
  width: 654px;
  margin-top: 34px;
  margin-bottom: 24px;
}

.info-message {
  color: rgba(55, 71, 79, 0.7);
  font-weight: 500;
  font-size: 14px;
}

@media(max-width: 768px) {
  .button-container{
    width: 100%;
    margin: 20px 0px;
  }
}
</style>
